import React from "react";

import Step from "../../../../../../atoms/Wizard/Step";
import ProductSummary from "../../../ProductSummary";
import Icon from "../../../../../../atoms/Icon/icon"
import styles from "./Step3.module.scss";
import i18n from "i18n";

export const RequestOrderStep3 = ({ dest, products, handleEditDest, handleEditProducts}) => {

    const stepContent = (
        <div className={styles["request-order-step-three-content"]}>
          <div className={styles["request-order-step-three-field"]} data-automation-id="input-search">
            <div className={styles["request-order-step-three-first-row"]}>
            <div className={styles[`request-order-step-title`]}>
                <div className={styles[`request-order-step-title-wrapper`]}> {i18n.t("order.origin")} </div>
                <div className={styles["request-order-step-three-icon-wrapper"]} onClick={handleEditDest}>
                  <Icon name="edit2" width={20} height={20} fill={"#3C7AF5"} />
                </div>
            </div>
            <div className={styles[`request-order-step-dest`]}>
               {dest}
            </div>
            </div>

            <div className={styles["request-order-step-three-second-row"]}>
              <ProductSummary
                products={products}
                edit={true}
                handleEdit={handleEditProducts}
              />
            </div>
          </div>

        </div>
      );
    return (
        <div className={styles["request-order-step-three-container"]}>
          <Step title={i18n.t("check.data")} content={stepContent}></Step>
        </div>
      );
}

export default RequestOrderStep3